export default __webpack_public_path__ + "static/invasive-species-hero-3f5ab92b0c862b08af077abf5d3c65c4.jpg";